//Had to extract this out as a helper function because Jest does not work well with hooks, causing this function to have to be exported in order to mock it.
const renderOptions = (options) =>
	options.map((option) => (
		<option value={option.key} key={option.key}>
			{option.text}
		</option>
	));

export default renderOptions;
